import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useLang } from '../context/LangContext';
import ServiceDetail from '../components/ServiceDetail';
// 导入服务图片
import ivTherapy from '../assets/images/halo services/iv.jpg';
import mesotherapy from '../assets/images/halo services/mesotherapy.jpg';
import prp from '../assets/images/halo services/prp.jpg';
import filler from '../assets/images/halo services/dermalfiller.jpeg';
import neurotoxin from '../assets/images/halo services/botox.jpg';
import belkyra from '../assets/images/halo services/belkyra.png';
import sculptra from '../assets/images/halo services/sculptra.jpg';
import radiesse from '../assets/images/halo services/radiesse.jpg';
import harmonyca from '../assets/images/halo services/harmonyca.png';
import instalift from '../assets/images/halo services/instalift.jpg';
import hydrafacial from '../assets/images/halo services/hydrafacial.jpg';
import bblHero from '../assets/images/halo services/BBLHERO.png';
import ultherapy from '../assets/images/halo services/ultherapy.png';
import potenza from '../assets/images/halo services/Potenza.jpg';
import visia from '../assets/images/halo services/visia.png';
import bodyfiller from '../assets/images/halo services/bodyfiller.jpg';
import belkyrabody from '../assets/images/halo services/belkyrabody.jpg';
import ultherapybody from '../assets/images/halo services/ultherapybody.jpg';
import skincare from '../assets/images/halo services/soft2.jpg';
import skinTagRemoval from '../assets/images/halo services/hyfracator.png';
import picosurePro from '../assets/images/halo services/picosurepro.png';
import microneedlingImage from '../assets/images/halo services/microneedling.jpeg';
import thermage from '../assets/images/halo services/thermage.png';

const content = {
  en: {
    pageTitle: 'Our Services',
    pageDesc: 'We provide professional medical aesthetics services to help you shine with confidence.',
    categories: [
      { id: 'all', name: 'All Services' },
      { id: 'injection', name: 'Injection Beauty' },
      { id: 'skin', name: 'Skin Care' },
      { id: 'body', name: 'Body Shaping' },
    ],
    services: [
      {
        id: 1,
        category: 'injection',
        title: 'IV Therapy',
        description: "Derma-Bright | Myers | Meta-Burn | Sweet Dreams | NAD+",
        image: ivTherapy,
        purpose: "To replenish hydration, boost energy, and deliver essential vitamins, minerals, and antioxidants directly into the bloodstream",
        mechanism: "Nutrients are administered intravenously, bypassing the digestive system for optimal absorption and immediate effect",
        duration: "Effects are usually felt immediately and can last from several days to 1–2 weeks, depending on lifestyle and body needs",
        features: [
          'Immediate hydration and nutrition',
          'Energy level enhancement',
          'Immune system support',
          'Skin brightening benefits',
        ],
        subServices: [
          {
            name: 'IV Derma-Bright',
            ingredients: 'Glutathione + Vitamin C',
            benefits: [
              'Protects cells from damage caused by free radicals and helps detoxify the body',
              'Can improve skin complexion, brightness, and overall health',
              'Supports overall health and may slow the signs of aging',
            ],
          },
          {
            name: 'IV Myers',
            ingredients: 'Vitamin B-complex + Vitamin C + Minerals + Amino acids',
            benefits: [
              'B vitamins are essential for energy metabolism and can help reduce fatigue',
              'Vitamin C and other minerals can help support the immune system',
              'It can help athletes and others recover from physical exertion by replenishing nutrients and fluids lost through sweat',
              'May help reduce inflammation and muscle soreness, and aid in recovery from illness',
              'It is used for a wide range of ailments, including chronic fatigue syndrome, fibromyalgia, migraines, muscle spasms, and upper respiratory infections',
            ],
          },
          {
            name: 'IV Meta-Burn',
            ingredients: 'Vitamins + B12-complex + Minerals + Amino acids',
            benefits: [
              'Lipotropic compounds help the liver process and remove fat from the body more efficiently',
              'The blend of nutrients is designed to speed up the body\'s metabolic processes',
              'Key components like Vitamin B12 contribute to increased energy levels',
            ],
          },
          {
            name: 'IV Sweet Dreams',
            ingredients: 'Vitamins + Trace Minerals + Amino acids',
            benefits: [
              'Helps increase serotonin levels for better sleep quality and reduces symptoms of insomnia',
              'Supports the production of key neurotransmitters involved in calming the nervous system',
              'Helps activate the parasympathetic nervous system which helps with a sense of calmness and relaxation',
            ],
          },
          {
            name: 'IV NAD+',
            ingredients: 'NAD+',
            benefits: [
              'It slows down the aging process. By replenishing your supply of NAD+, this special type of vitamin therapy effectively addresses aging at the cellular level to help you look and feel younger',
              'It improves your brain power and mental clarity. The older we get, the more our cognitive abilities tend to decrease. NAD+ IV therapy helps increase concentration and focus, as well as improve memory and mood, thereby enabling you to be more productive, make better decisions, and enjoy a better quality of life',
              'It combats fatigue and increases your energy. NAD+ IV therapy helps supply your body with the energy and drive it needs on a cellular level',
              'It reduces inflammation that causes damage to your cells and DNA. Certain amounts of NAD+ IV therapy enable your cells to activate enzymes that prevent and correct DNA damage caused by inflammatory foods, inhaled pollutants, and exposure to toxic chemicals',
              'It helps ease stress. Oxidative stress, an imbalance between free radicals and your body\'s ability to counteract with antioxidants, along with the stress of modern living, can sap your body of its natural NAD+ supply. NAD+ IV infusions restore this vital coenzyme to your system, enabling your body to ward off the harmful physiological effects of stress and anxiety',
            ],
          },
        ],
      },
      {
        id: 2,
        category: 'injection',
        title: 'Mesotherapy',
        description: 'Tiny injections of vitamins and nutrients placed under the skin to rejuvenate, brighten, hydrate, and improve texture',
        image: mesotherapy,
        purpose: 'Tiny injections of vitamins and nutrients placed under the skin to rejuvenate, brighten, hydrate, and improve texture',
        mechanism: 'Microinjections of vitamins, amino acids, hyaluronic acid (HA) and minerals are delivered into the middle layer of the skin (mesoderm)',
        duration: 'Skin-brightening and hydrating results last about 3–6 months after a series of treatments',
        features: [
          'Skin rejuvenation',
          'Improved texture',
          'Enhanced hydration',
          'Natural-looking results',
        ],
      },
      {
        id: 3,
        category: 'injection',
        title: 'PRP (Platelet-Rich Plasma)',
        description: 'Using your own blood\'s healing factors, PRP stimulates collagen, improves skin quality, reduce scars, and can even help with hair growth',
        image: prp,
        purpose: 'Using your own blood\'s healing factors, PRP stimulates collagen, improves skin quality, reduce scars, and can even help with hair growth',
        mechanism: 'A patient\'s own blood is processed to concentrate platelets, which release growth factors that aid in cell repair and regeneration when injected into the skin or scalp',
        duration: 'Results gradually appear within weeks and can last 12–18 months after 3–4 sessions',
        features: [
          'Natural collagen stimulation',
          'Improved skin quality',
          'Scar reduction',
          'Hair growth support',
        ],
      },
      {
        id: 4,
        category: 'injection',
        title: 'Dermal Filler',
        description: 'Juvederm | Stylage',
        image: filler,
        purpose: 'Instantly restores volume, smooths wrinkles, and enhances facial features using hyaluronic acid',
        mechanism: 'Hyaluronic acid or biostimulatory fillers are injected beneath the skin to provide support, hydration, or stimulate collagen production',
        duration: 'Hyaluronic acid fillers typically last 6–18 months depending on product type and area treated',
        features: [
          'Instant volume restoration',
          'Wrinkle reduction',
          'Enhanced facial contours',
          'Natural-looking results',
        ],
      },
      {
        id: '4b',
        category: 'body',
        title: 'Dermal Filler for body',
        description: 'Juvederm | Revanesse Countour XL',
        image: bodyfiller,
        purpose: 'Instantly restores volume, smooths wrinkles, and enhances facial features using hyaluronic acid',
        mechanism: 'Hyaluronic acid or biostimulatory fillers are injected beneath the skin to provide support, hydration, or stimulate collagen production',
        duration: 'Hyaluronic acid fillers typically last 6–18 months depending on product type and area treated',
        features: [
          'Instant volume restoration',
          'Wrinkle reduction',
          'Enhanced facial contours',
          'Natural-looking results',
        ],
      },
      {
        id: 5,
        category: 'injection',
        title: 'Neurotoxin',
        description: 'Botox | Dysport | Xeomin',
        image: neurotoxin,
        purpose: 'Softens expression lines like frown lines, forehead wrinkles, and crow\'s feet by relaxing overactive muscles. Improves facial contour, creates a V-shape effect, and enhances overall definition of the lower face',
        mechanism: 'Temporarily blocks nerve signals to muscles, preventing contraction and softening wrinkles',
        duration: 'Results appear within 5-10 days and last about 3–4 months',
        features: [
          'Wrinkle reduction',
          'Facial muscle relaxation',
          'Preventative anti-aging',
          'Enhanced facial definition',
        ],
      },
      {
        id: 6,
        category: 'injection',
        title: 'Belkyra (Kybella)',
        description: 'An injectable treatment that permanently reduces double chin by dissolving fat cells.',
        image: belkyra,
        purpose: 'An injectable treatment that permanently reduces double chin by dissolving fat cells. Multiple sessions may be required for optimal contouring',
        mechanism: 'Deoxycholic acid is injected to break down fat cell membranes, leading to gradual fat elimination through natural metabolic processes',
        duration: 'Permanent reduction once fat cells are destroyed, though multiple sessions may be required',
        features: [
          'Double chin reduction',
          'Permanent fat dissolution',
          'Jawline definition',
          'No surgery required',
        ],
      },
      {
        id: '6b',
        category: 'body',
        title: 'Belkyra (Kybella) for body',
        description: 'An injectable treatment that permanently reduces double chin by dissolving fat cells.',
        image: belkyrabody,
        purpose: 'An injectable treatment that permanently reduces double chin by dissolving fat cells. Multiple sessions may be required for optimal contouring',
        mechanism: 'Deoxycholic acid is injected to break down fat cell membranes, leading to gradual fat elimination through natural metabolic processes',
        duration: 'Permanent reduction once fat cells are destroyed, though multiple sessions may be required',
        features: [
          'Double chin reduction',
          'Permanent fat dissolution',
          'Jawline definition',
          'No surgery required',
        ],
      },
      {
        id: 7,
        category: 'injection',
        title: 'Sculptra',
        description: 'A collagen stimulator that gradually restores facial volume and improves skin quality over time',
        image: sculptra,
        purpose: 'A collagen stimulator that gradually restores facial volume and improves skin quality over time',
        mechanism: 'Made of poly-L-lactic acid (PLLA), Sculptra works gradually by stimulating collagen production over time rather than giving instant volume',
        duration: 'Results develop over several months and last up to 2–3 years after a series of treatments',
        features: [
          'Natural collagen growth',
          'Long-lasting volume',
          'Full face rejuvenation',
          'Gradual improvement',
        ],
      },
      {
        id: 8,
        category: 'injection',
        title: 'Radiesse',
        description: 'Provides immediate lift and long-term skin improvement. It adds volume while also stimulating your own collagen',
        image: radiesse,
        purpose: 'Provides immediate lift and long-term skin improvement. It adds volume while also stimulating your own collagen',
        mechanism: 'Composed of calcium hydroxylapatite (CaHA) microspheres suspended in a gel, Radiesse provides immediate volume while stimulating collagen production',
        duration: 'Lasts 12–18 months, with ongoing improvement in skin texture due to collagen stimulation',
        features: [
          'Immediate volumization',
          'Collagen stimulation',
          'Hand rejuvenation',
          'Natural-looking results',
        ],
      },
      {
        id: 18,
        category: 'injection',
        title: 'HArmonyCa Injectable',
        description: 'Dual-effect hybrid injectable combining Calcium Hydroxyapatite (CaHA) and Hyaluronic Acid (HA).',
        image: harmonyca,
        purpose: 'Immediate lifting effect from HA + long-term collagen stimulation from CaHA. Improves skin architecture.',
        mechanism: 'Combines hyaluronic acid for instant volumization and lift with calcium hydroxyapatite (CaHA) microspheres that stimulate natural collagen production over time, rebuilding deeper skin structure.',
        duration: 'HA provides immediate results while CaHA collagen stimulation continues to improve skin quality over several months; longevity varies by treatment area and individual response.',
        features: [
          'Immediate lifting from hyaluronic acid',
          'Long-term collagen stimulation from CaHA',
          'Improved skin architecture and texture',
          'Ideal for overall skin laxity',
        ],
      },
      {
        id: 19,
        category: 'injection',
        title: 'Silhouette InstaLift / Thread Lifting',
        description: 'Minimally invasive injectable micro-suspension technology using absorbable threads.',
        image: instalift,
        purpose: 'Instant mechanical lifting of deep layers + continuous collagen production to re-define facial contours.',
        mechanism: 'Absorbable bidirectional threads are placed beneath the skin to provide immediate mechanical lift while stimulating collagen production as they dissolve, gradually restoring facial structure.',
        duration: 'Immediate lifting is visible after treatment; collagen remodeling continues over 3–6 months with results lasting approximately 12–18 months depending on individual factors.',
        features: [
          'Instant mechanical lift of deep tissue',
          'Continuous collagen production',
          'Non-surgical facial contour redefinition',
          'Ideal for improving lower face sagging',
        ],
      },
      {
        id: 9,
        category: 'skin',
        title: 'HydraFacial',
        description: 'A non-invasive, multi-step facial treatment that cleanses, exfoliates, and hydrates the skin',
        image: hydrafacial,
        purpose: 'A non-invasive, multi-step facial treatment that cleanses, exfoliates, and hydrates the skin. Its primary goals are deep cleansing, intense hydration, improving skin texture and tone, refining pores, and providing an immediate glow',
        mechanism: 'Utilizes a proprietary Vortex-Fusion® delivery system. A handheld tip simultaneously performs two actions: 1. Cleansing and Exfoliation: Delivers gentle chemical solutions (like glycolic and salicylic acid) to loosen dirt, dead skin cells, and impurities from the pores. 2. Hydration and Infusion: Extracts the impurities while infusing the skin with a cocktail of customized serums rich in antioxidants, peptides, and hyaluronic acid',
        duration: 'A standard treatment session typically takes approximately 30-60 minutes',
        features: [
          'Deep cleansing',
          'Gentle exfoliation',
          'Intense hydration',
          'Immediate glow',
        ],
      },
      {
        id: 10,
        category: 'skin',
        title: 'BBL (BroadBand Light) HERO',
        description: 'Most advanced and powerful intense pulsed light technology for treating a wide range of skin concerns',
        image: bblHero,
        purpose: 'Most advanced and powerful intense pulsed light technology for treating a wide range of skin concerns. Key applications include: Pigment Lesions: Removing sun spots and age spots. Vascular Lesions: Reducing facial redness, broken capillaries, and redness associated with rosacea. Skin Rejuvenation: Stimulating collagen to improve fine lines, pore size, and overall skin tone',
        mechanism: 'IPL (Intense Pulsed Light) technology. It emits a broad spectrum of light that is absorbed by specific targets in the skin (chromophores), primarily melanin (pigment) and hemoglobin (in blood vessels). Absorbed light energy converts to heat, destroying the targeted pigment or vessel, which is then naturally cleared by the body. The gentle heating of the skin also stimulates fibroblasts in the dermis to stimulate collagen, leading to long-term skin tightening and rejuvenation',
        duration: 'Treatment time varies by treating area. A full face treatment typically takes approximately 20-45 minutes',
        features: [
          'Pigment reduction',
          'Redness treatment',
          'Skin tone evening',
          'Sun damage repair',
        ],
      },
      {
        id: 11,
        category: 'skin',
        title: 'Ulthera Prime',
        description: 'Marketed as the only non-invasive procedure FDA-cleared to truly lift skin',
        image: ultherapy,
        purpose: 'Marketed as the only non-invasive procedure FDA-cleared to truly lift skin. It is specifically designed for individuals with mild to moderate skin laxity. It does not address pigmentation, vascular issues, or reduce fat',
        mechanism: 'Uses micro-focused ultrasound energy with real-time visualization. Ultrasound waves are precisely focused at specific depths beneath the skin\'s surface (including the foundational SMAS layer, targeted in surgical facelifts). At each focal point, the energy creates microscopic thermal injuries, which trigger the body\'s natural healing response, resulting in significant neocollagenesis (the production of new collagen). This process gradually tightens and lifts the skin over 2-3 months',
        duration: 'A single treatment session typically takes 60-90 minutes, depending on the areas being treated',
        features: [
          'Non-invasive skin lifting',
          'Collagen stimulation',
          'Skin tightening',
          'Long-lasting results',
        ],
      },
      {
        id: '11b',
        category: 'body',
        title: 'Ulthera Prime for body',
        description: 'Marketed as the only non-invasive procedure FDA-cleared to truly lift skin',
        image: ultherapybody,
        purpose: 'Marketed as the only non-invasive procedure FDA-cleared to truly lift skin. It is specifically designed for individuals with mild to moderate skin laxity. It does not address pigmentation, vascular issues, or reduce fat',
        mechanism: 'Uses micro-focused ultrasound energy with real-time visualization. Ultrasound waves are precisely focused at specific depths beneath the skin\'s surface (including the foundational SMAS layer, targeted in surgical facelifts). At each focal point, the energy creates microscopic thermal injuries, which trigger the body\'s natural healing response, resulting in significant neocollagenesis (the production of new collagen). This process gradually tightens and lifts the skin over 2-3 months',
        duration: 'A single treatment session typically takes 60-90 minutes, depending on the areas being treated',
        features: [
          'Non-invasive skin lifting',
          'Collagen stimulation',
          'Skin tightening',
          'Long-lasting results',
        ],
      }, 
      {
        id: 12,
        category: 'skin',
        title: 'Radio Frequency Microneedling | Potenza',
        description: 'Potenza is a device that combines microneedling with radiofrequency (RF) energy',
        image: potenza,
        purpose: 'Potenza is a device that combines microneedling with radiofrequency (RF) energy. It is designed for precise treatment of the face and body. Primary indications include: Acne Scarring, Wrinkles and Skin Texture, Pore Reduction, Skin Tightening and resurfacing',
        mechanism: 'This direct application of heat causes immediate tissue contraction and stimulates a robust wound-healing response, leading to long-term remodeling and production of new collagen and elastin. Its key feature is customizable depth and RF frequency for personalized treatments',
        duration: 'A full face treatment typically takes approximately 30-60 minutes. Topical anesthesia is required prior to the procedure',
        features: [
          'Collagen induction',
          'Scar reduction',
          'Skin tightening',
          'Texture improvement',
        ],
      },
      {
        id: 13,
        category: 'skin',
        title: 'Spectrum Therapy™',
        description: 'Different wavelengths are used for different purposes',
        image: skincare,
        purpose: 'Different wavelengths are used for different purposes: Blue Light: Targets for acne treatment and prevention. Red Light: Penetrates deeper to reduce inflammation, promote circulation, and stimulate collagen production for anti-aging and skin rejuvenation. Yellow Light: Used to calm the skin, reduce redness, and soothe inflammation',
        mechanism: 'Uses Light Emitting Diodes to deliver specific wavelengths of non-thermal (cool) light, initiating a photobiomodulation effect that enhances cellular metabolism, energy production, and natural repair processes. It is a gentle, non-destructive process',
        duration: 'A single session is relatively short, typically requiring about 10-20 minutes of exposure. It is often used as an adjunctive therapy after sunburnt or skin irritation or other procedures or in a series of treatments for cumulative benefits',
        features: [
          'Acne treatment',
          'Anti-inflammation',
          'Collagen boost',
          'Healing support',
        ],
      },
      {
        id: 14,
        category: 'skin',
        title: 'Visia® Skin Analysis',
        description: 'A high-resolution skin imaging and analysis system',
        image: visia,
        purpose: 'A high-resolution skin imaging and analysis system. It is designed to provide an objective, quantitative assessment of the skin\'s condition',
        mechanism: 'Captures standardized, high-quality facial images under standard, cross-polarized, and UV lighting using a fixed positioning system. Sophisticated software analyzes the images to quantify various skin features',
        duration: 'The complete process of capturing images and generating a report typically takes approximately 15 minutes',
        features: [
          'Objective skin assessment',
          'High-resolution imaging',
          'Quantitative analysis',
          'Comprehensive skin evaluation',
        ],
      },
      {
        id: 15,
        category: 'skin',
        title: 'Skin Tag Removal',
        description: 'Safe and effective removal of skin tags using Hyfrecator electrocoagulation',
        image: skinTagRemoval,
        purpose: 'Safe and effective removal of skin tags, moles, and warts using Hyfrecator electrocoagulation technology. This treatment is ideal for removing superficial junctional nevi and deeper, raised compound nevi or warts',
        mechanism: 'Uses Hyfrecator electrocoagulation pen that applies high-temperature cauterization principle. The heat causes the skin tag or wart to be burned and carbonized, leading to its removal. The procedure is precise and controlled, minimizing damage to surrounding healthy tissue',
        duration: 'Treatment typically takes 15-30 minutes depending on the number and size of skin tags. Healing time is usually 1-2 weeks',
        features: [
          'Precise removal technique',
          'Minimal discomfort',
          'Quick procedure',
          'Safe for surrounding tissue',
        ],
      },
      {
        id: 16,
        category: 'skin',
        title: 'PicoSure Pro',
        description: 'The World\'s First 755nm Picosecond Laser for safe and effective pigment removal, wrinkle reduction, and skin revitalization',
        image: picosurePro,
        purpose: 'PicoSure Pro delivers 755nm energy in picoseconds, sparing the skin from high thermal damage while optimally targeting unwanted pigment, wrinkles, acne scars, and pores with less downtime than traditional lasers. It is the only picosecond device FDA-cleared to treat melasma pigment, nevus of Ota and Hori\'s nevus',
        mechanism: 'The device uses picosecond laser technology that delivers energy so quickly it minimizes thermal damage to surrounding tissue. It features One Zoom handpiece (2-6mm) and Four fixed handpieces (5, 6, 8, 10mm) with adjustable fluence for customizable treatments. The Platinum Focus™ lens provides unique skin revitalization with no downtime, while the flat lens treats unwanted pigment in all skin types. Optional 532nm and 1064nm add-on capabilities are available for tattoo removal',
        duration: 'Treatment time varies by area and condition. Most treatments take 15-30 minutes per session. Results improve over time with minimal to no downtime',
        features: [
          'Safe pigment removal in all skin types',
          'FDA-cleared for melasma, nevus of Ota and Hori\'s nevus',
          'Wrinkle and fine line reduction',
          'Acne scar and pore size improvement',
          'No downtime treatment',
          'Skin tone and texture enhancement',
        ],
      },
      {
        id: 17,
        category: 'skin',
        title: 'Microneedling Treatments',
        description: 'PDRN Microneedling | Lumiere Infusion Microneedling | HA Infusion Microneedling',
        image: microneedlingImage, // 替换为实际图片变量
        purpose: 'Enhances skin texture, hydration, and rejuvenation by stimulating collagen and delivering nutrients directly into the skin',
        mechanism: 'Micro-needles create tiny channels in the skin, promoting collagen production and allowing infusion of PDRN, vitamins, hyaluronic acid, or other active ingredients for targeted skin improvement',
        duration: 'Visible improvements in skin texture, hydration, and radiance usually appear within weeks; results may last 3–6 months depending on treatment type and skin condition',
        features: [
          'Collagen stimulation',
          'Skin hydration and rejuvenation',
          'Improved texture and elasticity',
          'Targeted nutrient delivery',
        ],
        subServices: [
          {
            name: 'PDRN Microneedling',
            benefits: [
              'Stimulates tissue regeneration and collagen synthesis',
              'Improves skin repair and overall skin quality',
            ],
          },
          {
            name: 'Lumiere Infusion Microneedling',
            benefits: [
              'Delivers vitamins and antioxidants deep into the skin',
              'Brightens complexion and restores radiance',
            ],
          },
          {
            name: 'HA Infusion Microneedling',
            benefits: [
              'Provides deep hydration and plumps the skin',
              'Enhances elasticity and smoothness',
            ],
          },
        ],
      },
      {
        id: 20,
        category: 'skin',
        title: 'Thermage® FLX',
        description: 'FDA-cleared non-invasive monopolar radiofrequency (RF) treatment that tightens, smooths, and contours skin on the eyes, face, neck, and body.',
        image: thermage,
        purpose: 'FDA-cleared monopolar radiofrequency treatment designed for skin tightening, contouring, and wrinkle smoothing. It targets skin laxity across the eyes, face, neck, and body (including abdomen, arms, thighs, and buttocks).',
        mechanism: 'Delivers targeted monopolar radiofrequency (RF) energy deep into collagen-rich dermal layers and subcutaneous tissue. Features AccuREP™ technology for automated energy calibration per pulse, combined with vibration cooling for optimal results and comfort.',
        duration: 'A treatment session typically lasts 45–90 minutes depending on the area treated (eyes, face, neck, or body). Results develop over 2–6 months and can last 12–24 months.',
        features: [
          'Eye, face, neck & body tightening',
          'AccuREP™ smart RF energy delivery',
          'Deep collagen stimulation & remodeling',
          'Non-invasive with zero downtime',
        ],
      },
    ],
    details: 'View Details',
  },
  cn: {
    pageTitle: '服务项目',
    pageDesc: '我们提供专业的医美服务，让您焕发自信光彩',
    categories: [
      { id: 'all', name: '全部服务' },
      { id: 'injection', name: '注射美容' },
      { id: 'skin', name: '皮肤护理' },
      { id: 'body', name: '身体塑形' },
    ],
    services: [
      {
        id: 1,
        category: 'injection',
        title: '静脉营养疗法（IV Therapy）',
        description: 'Derma-Bright | Myers | Meta-Burn | Sweet Dreams | NAD+',
        image: ivTherapy,
        purpose: '快速补充水分，提升能量，将必需的维生素、矿物质及抗氧化剂直接输送至血液中',
        mechanism: '通过静脉输注，营养物质绕过消化系统，直接被身体高效吸收，迅速发挥作用',
        duration: '通常可立即感受到效果，持续数天至1–2周，因生活方式和身体需求而异',
        features: [
          '即时补水和营养吸收',
          '能量水平提升',
          '免疫系统支持',
          '美白亮肤功效',
        ],
        subServices: [
          {
            name: 'IV Derma-Bright',
            ingredients: '谷胱甘肽 + 维生素C',
            benefits: [
              '保护细胞免受自由基损伤，帮助身体排毒',
              '可改善肤色、亮度和整体健康',
              '支持整体健康，可能延缓衰老迹象',
            ],
          },
          {
            name: 'IV Myers',
            ingredients: '维生素B复合物 + 维生素C + 矿物质 + 氨基酸',
            benefits: [
              'B族维生素对能量代谢至关重要，有助于减少疲劳',
              '维生素C和其他矿物质有助于支持免疫系统',
              '可帮助运动员和普通人通过补充因出汗而流失的营养和液体来恢复体力',
              '可能有助于减少炎症和肌肉酸痛，并帮助从疾病中恢复',
              '用于多种疾病，包括慢性疲劳综合征、纤维肌痛、偏头痛、肌肉痉挛和上呼吸道感染',
            ],
          },
          {
            name: 'IV Meta-Burn',
            ingredients: '维生素 + B12复合物 + 矿物质 + 氨基酸',
            benefits: [
              '亲脂性化合物帮助肝脏更有效地处理和清除体内脂肪',
              '营养混合物旨在加速身体的代谢过程',
              '维生素B12等关键成分有助于提高能量水平',
            ],
          },
          {
            name: 'IV Sweet Dreams',
            ingredients: '维生素 + 微量矿物质 + 氨基酸',
            benefits: [
              '有助于提高血清素水平，改善睡眠质量，减少失眠症状',
              '支持参与镇静神经系统的关键神经递质的产生',
              '有助于激活副交感神经系统，带来平静和放松感',
            ],
          },
          {
            name: 'IV NAD+',
            ingredients: 'NAD+',
            benefits: [
              '延缓衰老过程。通过补充NAD+，这种特殊的维生素疗法可以在细胞水平上有效解决衰老问题，帮助您看起来和感觉更年轻',
              '改善大脑功能和心理清晰度。随着年龄增长，我们的认知能力往往会下降。NAD+ IV疗法有助于提高注意力和专注力，改善记忆和情绪，从而使您更高效、做出更好的决策，享受更好的生活质量',
              '对抗疲劳并增加能量。NAD+ IV疗法在细胞水平上为您的身体提供所需的能量和动力',
              '减少对细胞和DNA造成损害的炎症。一定量的NAD+ IV疗法使您的细胞能够激活酶，预防和纠正由炎症性食物、吸入污染物和接触有毒化学物质引起的DNA损伤',
              '有助于缓解压力。氧化应激是自由基与身体抗氧化能力之间的不平衡，加上现代生活的压力，可能会耗尽身体的天然NAD+供应。NAD+ IV输注将这种重要的辅酶恢复到您的系统中，使您的身体能够抵御压力和焦虑的有害生理影响',
            ],
          },
        ],
      },
      {
        id: 2,
        category: "injection",
        title: "水光针（Mesotherapy）",
        description: "通过微量注射维生素与营养成分，使肌肤焕亮、保湿、细腻，改善肤质",
        image: mesotherapy,
        purpose: "通过微量注射维生素与营养成分，使肌肤焕亮、保湿、细腻，改善肤质",
        mechanism: "将维生素、氨基酸、透明质酸（HA）、矿物质等活性成分直接注入真皮中层（即\"中胚层\"）",
        duration: "完成一个疗程后，亮白与保湿效果可维持约3–6个月",
        features: [
          '肌肤焕新',
          '改善肤质',
          '深度补水',
          '自然效果',
        ],
      },
      {
        id: 3,
        category: 'injection',
        title: '血清疗法（PRP）',
        description: '利用自身血液中的修复因子，刺激胶原生成，改善肤质、淡化疤痕，同时也可用于促进头发生长',
        image: prp,
        purpose: "利用自身血液中的修复因子，刺激胶原生成，改善肤质、淡化疤痕，同时也可用于促进头发生长",
        mechanism: "抽取自身血液并浓缩血小板，再将其注射至皮肤或头皮，释放生长因子，促进细胞修复与再生",
        duration: "治疗数周后逐渐见效，完成3–4次疗程后，效果可持续12–18个月",
        features: [
          '天然胶原刺激',
          '改善皮肤质量',
          '疤痕淡化',
          '促进头发生长',
        ],
      },
      {
        id: 4,
        category: 'injection',
        title: '玻尿酸填充剂（Dermal Filler）',
        description: '乔雅登 I 丝丽',
        image: filler,
        purpose: "立即恢复流失的面部容积，平滑皱纹，勾勒轮廓，用玻尿酸塑造更年轻的面部线条",
        mechanism: "将玻尿酸或胶原刺激型填充剂注射于皮下，起到支撑、补水或促进胶原生成的作用",
        duration: "依照产品类型与注射部位不同，维持时间约6–18个月",
        features: [
          '即时容积恢复',
          '皱纹减少',
          '面部轮廓提升',
          '自然效果',
        ],
      },
      {
        id: 5,
        category: 'injection',
        title: '肉毒素（Neurotoxin）',
        description: 'Botox | Dysport | Xeomin',
        image: neurotoxin,
        purpose: "放松过度活跃的表情肌，减淡皱眉纹、抬头纹、鱼尾纹，改善下颌线条，塑造立体V脸，提升整体面部轮廓感",
        mechanism: "通过阻断神经与肌肉的信号传递，减少肌肉收缩，从而软化动态纹路",
        duration: "5–10天左右显现，维持约3–4个月",
        features: [
          '表情纹减少',
          'V脸轮廓塑造',
          '预防性抗衰老',
          '保持自然表情',
        ],
      },
      {
        id: 6,
        category: 'injection',
        title: '溶脂针（Belkyra / Kybella）',
        description: '专为下颌脂肪（双下巴）设计的注射疗程，可永久减少脂肪细胞，重塑下颌线条',
        image: belkyra,
        purpose: "专为下颌脂肪（双下巴）设计的注射疗程，可永久减少脂肪细胞，重塑下颌线条",
        mechanism: "注射去氧胆酸，破坏脂肪细胞膜，使其逐渐通过新陈代谢自然排出体外",
        duration: "脂肪细胞一旦被清除，即为永久性效果；通常需多次治疗以达最佳改善",
        features: [
          '永久性减脂',
          '改善下颌轮廓',
          '无需手术',
          '自然效果',
        ],
      },
      {
        id: 7,
        category: 'injection',
        title: '童颜针（Sculptra）',
        description: '通过刺激自身胶原生成，逐步恢复面部体积，改善皮肤质感，实现自然、持久的年轻化效果',
        image: sculptra,
        purpose: "通过刺激自身胶原生成，逐步恢复面部体积，改善皮肤质感，实现自然、持久的年轻化效果",
        mechanism: "由聚左旋乳酸（PLLA）组成，注射后逐渐促进胶原新生，而非单纯增加即时体积",
        duration: "数月后逐步显现，完整疗程可维持2–3年",
        features: [
          '自然容积恢复',
          '长期效果',
          '渐进式改善',
          '全面面部年轻化',
        ],
      },
      {
        id: 8,
        category: 'injection',
        title: '瑞得喜（Radiesse）',
        description: '兼具"立刻填充"与"长期改善"双重功效，既能即时增加面部支撑力，也能刺激胶原生成，让肤质随时间愈加紧致平滑',
        image: radiesse,
        purpose: "兼具\"立刻填充\"与\"长期改善\"双重功效，既能即时增加面部支撑力，也能刺激胶原生成，让肤质随时间愈加紧致平滑",
        mechanism: "由羟基磷灰石钙（CaHA）微球悬浮于凝胶中，注射后既能立即填充流失体积，又能长期激活胶原生成",
        duration: "可维持12–18个月，并伴随皮肤质感的逐渐提升",
        features: [
          '即时填充',
          '持续改善',
          '自然效果',
          '胶原刺激',
        ],
      },
      {
        id: 18,
        category: 'injection',
        title: 'HArmonyCa美神针 / 双效胶原针',
        description: '结合透明质酸（玻尿酸）与羟基磷灰石钙（微晶瓷）的双效混合注射剂。',
        image: harmonyca,
        purpose: '玻尿酸带来即时提升效果 + 微晶瓷持续刺激自身胶原蛋白再生，深层重塑肌肤架构。',
        mechanism: '将透明质酸（玻尿酸）的即时填充提升与羟基磷灰石钙（微晶瓷）微球的长期胶原刺激相结合，从深层逐步重建肌肤支撑结构。',
        duration: '玻尿酸可带来即时改善，微晶瓷的胶原刺激效果在数月内持续显现；维持时间因治疗部位与个人体质而异。',
        features: [
          '玻尿酸即时提升与填充',
          '微晶瓷持续刺激胶原再生',
          '深层重塑肌肤架构与质地',
          '适用于中下部面部松弛、下颌线模糊及整体皮肤松弛',
        ],
      },
      {
        id: 19,
        category: 'injection',
        title: 'Silhouette InstaLift 铃铛线 / 线雕提升',
        description: '采用可吸收线材的微创微悬浮注射/植入技术。',
        image: instalift,
        purpose: '物理性即时提升深层组织，同时持续诱导胶原蛋白增生，非手术式重塑面部轮廓。',
        mechanism: '将可吸收双向线材植入皮下，提供即时物理性提拉，并在吸收过程中持续刺激胶原新生，逐步恢复面部支撑结构。',
        duration: '治疗后即可见即时提升；胶原重塑在3–6个月内持续进行，效果通常可维持约12–18个月，因个人情况而异。',
        features: [
          '深层组织即时物理性提升',
          '持续诱导胶原蛋白增生',
          '非手术式重塑面部轮廓',
          '适用于嘴角肉（木偶纹处）、面颊下垂、加深的老虎纹（鼻唇沟）及颈部轻度松弛',
        ],
      },
      {
        id: 9,
        category: 'skin',
        title: '海菲秀二代',
        description: '一种非侵入性的、三步合一（清洁、剥离、滋养）的活肤护理',
        image: hydrafacial,
        purpose: '一种非侵入性的、三步合一（清洁、剥离、滋养）的活肤护理。主要目的是深层清洁、补水保湿、改善肤质、提亮肤色和细化毛孔',
        mechanism: '采用独家专利的 Vortex-Fusion® 双向涡流技术，通过一个手持探头，同时进行：1. 清洁与剥离：使用温和的果酸和水杨酸溶液软化并清除老废角质和毛孔内的杂质。2. 精华灌注：在清除杂质的同时，将富含营养（如抗氧化剂、多肽、透明质酸）的精华液注入皮肤。整个过程类似于"给皮肤做吸尘和灌溉"，先吸走污垢，再注入营养，无需停机期',
        duration: '30-60分钟',
        features: [
          '深层清洁',
          '温和去角质',
          '深度补水',
          '即刻光彩',
        ],
      },
      {
        id: 10,
        category: 'skin',
        title: 'BBL (BroadBand Light) Hero | BB光',
        description: '目前市场里最先进和强大的强脉冲光技术，改善解决多种皮肤问题',
        image: bblHero,
        purpose: '目前市场里最先进和强大的强脉冲光技术，旨在解决多种皮肤问题。其功效广泛，包括：祛除色素性病变（如晒斑、老年斑）；祛除血管性病变（如面部红血丝、毛细血管扩张、玫瑰痤疮引起的红斑）；嫩肤（刺激胶原蛋白再生，改善细纹、毛孔粗大，提亮肤色）。其 Forever Young 技术，能作用于皮肤细胞层面来延缓皮肤衰老的基因',
        mechanism: '采用其他光子不具备的双灯双通道技术，相当于把原单灯能量降为一半，加大光斑，降低治疗痛感。BBL独有的S级抗衰波长（S590nm/S695特定近红外光）穿透至皮下4-5mm，突破传统光子治疗深度。刺激胶原重塑：深层热效应促进Ⅰ型/Ⅲ型胶原蛋白增生，重建皮肤支撑结构',
        duration: '单次治疗时间因治疗区域大小而异。例如，全面部治疗包含术后护理通常需要约30分钟',
        features: [
          '改善色素',
          '祛除红血丝',
          '均匀肤色',
          '修复光损伤',
        ],
      },
      {
        id: 11,
        category: 'skin',
        title: '二代超声刀Prime',
        description: '非手术方式提拉皮肤功效最强，维持时间最久的无创抗衰设备',
        image: ultherapy,
        purpose: '非手术方式提拉皮肤功效最强，维持时间最久的无创抗衰设备。它不用于减脂或解决色素、血管性问题，核心是"提拉"和"紧致"',
        mechanism: '采用聚焦式超声波技术。该技术能够将超声波能量精确地聚焦在皮下的特定目标深度（包括SMAS筋膜层，这是手术拉皮时作用的层次），而不损伤表皮。在皮下精准层次产生微小的热凝固点，这会启动身体的自然愈合反应，刺激大量新的胶原蛋白再生和重组。有部分即刻效果，在接下来的1-3个月，新生的胶原蛋白会逐渐使松弛的皮肤变得紧实、有弹性，实现提拉效果',
        duration: '一次治疗通常需要60-90分钟，具体时间取决于治疗区域',
        features: [
          '肌肤焕新',
          '改善痘痘',
          '抗衰老',
          '改善肤质',
        ],
      },
      {
        id: 12,
        category: 'skin',
        title: '黄金射频微针Potenza',
        description: '结合了微针和射频技术的高效皮肤管理仪器',
        purpose: 'Potenza是一种结合了微针和射频技术的设备。官方宣传其可用于全面部及身体的精准治疗，主要解决：痤疮瘢痕：尤其是凹陷性痘坑；重塑肤质：刺激皮肤焕新，消除炎症；松弛肌肤：紧致皮肤，改善细纹；毛孔粗大',
        mechanism: '通过微针在真皮层精确释放射频能量，产生可控的热刺激。这种"由内而外"的加热方式能高效刺激胶原蛋白和弹性蛋白的即刻收缩和长期新生，同时由于能量精准作用于深层，对表皮损伤极小。Potenza拥有十款针头和四种不同频率的射频，允许专业人员根据不同肤质和治疗深度进行个性化定制',
        duration: '全面部治疗通常需要约30-45分钟，术前需要敷表面麻醉膏',
        image: potenza,
        features: [
          '促进胶原蛋白',
          '改善疤痕',
          '紧致提升',
          '改善肤质',
        ],
      },
      {
        id: 13,
        category: 'skin',
        title: '光谱疗法',
        description: 'LED光疗技术，有效改善多种皮肤问题',
        image: skincare,
        purpose: 'LED光疗技术。蓝光针对痤疮丙酸杆菌，用于治疗和预防痤疮（痘痘）；红光深入皮肤组织，促进血液循环，减少炎症，刺激胶原蛋白生成，用于抗衰老和嫩肤。黄光用于舒缓皮肤，减少红肿和炎症，改善敏感肌肤',
        mechanism: '采用特定波长的非热能冷光，通过调节细胞的机能来发挥作用',
        duration: '单次治疗时间较短，通常每次照射需要约10-20分钟。常作为晒伤/皮肤发炎期/其他激光/光疗项目后的舒缓修复治疗，或需要定期多次治疗以维持效果',
        features: [
          '祛痘治疗',
          '消炎修复',
          '胶原促生',
          '辅助愈合',
        ],
      },
      {
        id: 14,
        category: 'skin',
        title: 'Visia® 皮肤检测',
        description: '高精度的皮肤图像分析系统，提供客观、量化的皮肤评估',
        image: visia,
        purpose: '高精度的皮肤图像分析系统，提供客观、量化的皮肤评估，检测肉眼难以看清的皮肤问题（如皮下色素、血管状况）',
        mechanism: '通过标准化定位（固定下巴和额头），在标准光、横断面偏振光、紫外光等多种光线下拍摄高清面部图像。利用复杂的软件算法，对图像进行分析和量化，从而给出一个客观的评估报告',
        duration: '一次完整的Visia皮肤检测和分析过程通常需要约15分钟',
        features: [
          '客观皮肤评估',
          '高分辨率成像',
          '定量分析',
          '全面皮肤评估',
        ],
      },
      {
        id: 15,
        category: 'skin',
        title: '皮肤赘生物去除',
        description: '使用Hyfrecator电凝笔安全有效地去除皮肤赘生物',
        image: skinTagRemoval,
        purpose: '使用Hyfrecator电凝笔技术安全有效地去除皮肤赘生物、痣和疣。此治疗适用于去除浅层的结合痣及较深而又凸起的复合痣或者疣',
        mechanism: '应用Hyfrecator电凝笔高温灼烧的原理，使疣由于烧灼、炭化而去除。该程序精确且受控，最大程度减少对周围健康组织的损伤',
        duration: '治疗时间通常为15-30分钟，具体取决于皮肤赘生物的数量和大小。愈合时间通常为1-2周',
        features: [
          '精确去除技术',
          '最小不适感',
          '快速程序',
          '对周围组织安全',
        ],
      },
      {
        id: 16,
        category: 'skin',
        title: 'PicoSure Pro 蜂巢皮秒二代',
        description: '全球首款755nm皮秒激光，安全有效地去除色素、减少皱纹、改善肤质',
        image: picosurePro,
        purpose: 'PicoSure Pro以皮秒级速度发射755nm能量，避免皮肤受到高热损伤，同时精准靶向去除多余色素、皱纹、痤疮疤痕和毛孔，相比传统激光恢复期更短。它是唯一获得FDA批准用于治疗黄褐斑、太田痣和颧部褐青色痣的皮秒设备',
        mechanism: '设备采用皮秒激光技术，能量传递速度极快，最大程度减少对周围组织的热损伤。配备一个可调焦手柄（2-6mm）和四个固定手柄（5、6、8、10mm），能量密度可调，实现个性化治疗。Platinum Focus™透镜提供独特的皮肤焕活效果，无需恢复期；平面透镜可治疗所有肤质类型的多余色素。可选配532nm和1064nm附加功能，用于纹身去除',
        duration: '治疗时间因治疗区域和病情而异。大多数治疗每次需要15-30分钟。效果随时间改善，几乎无需恢复期',
        features: [
          '安全去除所有肤质类型的色素',
          'FDA批准用于黄褐斑、太田痣和颧部褐青色痣',
          '减少皱纹和细纹',
          '改善痤疮疤痕和毛孔大小',
          '无恢复期治疗',
          '提升肤色和肤质',
        ],
      },
      {
        id: '4b',
        category: 'body',
        title: '玻尿酸填充（身体）',
        description: 'Juvederm | Revanesse Countour XL',
        image: bodyfiller,
        purpose: '立即恢复身体局部容积，平滑皱纹，提升轮廓',
        mechanism: '将玻尿酸或胶原刺激型填充剂注射于皮下，提供支撑、补水或刺激胶原生成',
        duration: '玻尿酸填充剂通常可维持6–18个月，视产品类型和注射部位而定',
        features: [
          '即时容积恢复',
          '皱纹改善',
          '轮廓提升',
          '自然效果',
        ],
      },
      {
        id: '6b',
        category: 'body',
        title: '溶脂针（身体）',
        description: 'Belkyra / Kybella',
        image: belkyrabody,
        purpose: '通过注射去氧胆酸，可永久减少身体局部脂肪细胞，重塑轮廓',
        mechanism: '破坏脂肪细胞膜，脂肪逐渐通过新陈代谢排出体外，多次治疗可达最佳效果',
        duration: '脂肪细胞清除后效果永久，多次治疗可获得最佳改善',
        features: [
          '局部脂肪减少',
          '永久性效果',
          '轮廓重塑',
          '无需手术',
        ],
      },
      {
        id: '11b',
        category: 'body',
        title: '二代超声刀Prime（身体）',
        description: '非手术提拉设备，专为身体松弛部位设计',
        image: ultherapybody,
        purpose: '非侵入式超声刀治疗身体松弛皮肤，紧致轮廓，提升弹性',
        mechanism: '利用聚焦超声波在皮下特定深度产生热效应，激活胶原新生，实现皮肤紧致和提升',
        duration: '单次治疗60–90分钟，根据治疗部位而定',
        features: [
          '非手术提拉',
          '胶原激活',
          '皮肤紧致',
          '持久效果',
        ],
      }, 
      {
        id: 17,
        category: 'skin',
        title: '微针疗法',
        description: 'PDRN微针 | Lumiere精华微针 | HA精华微针',
        image: microneedlingImage, // 替换为实际图片变量
        purpose: '通过刺激胶原生成并将营养直接输送至皮肤，改善肤质、保湿和焕活肌肤',
        mechanism: '微针在皮肤上产生微小通道，促进胶原生成，同时输送PDRN、维生素、透明质酸或其他活性成分，实现针对性改善',
        duration: '肤质改善、补水及光泽通常在数周内可见效果，视治疗类型和皮肤情况，效果可持续3–6个月',
        features: [
          '胶原激活',
          '皮肤补水与焕活',
          '改善肤质与弹性',
          '营养成分精准输送',
        ],
        subServices: [
          {
            name: 'PDRN微针',
            benefits: [
              '促进组织再生与胶原生成',
              '改善皮肤修复能力和整体肤质',
            ],
          },
          {
            name: 'Lumiere精华微针',
            benefits: [
              '将维生素和抗氧化剂深层输送至皮肤',
              '提亮肤色，恢复光泽',
            ],
          },
          {
            name: 'HA精华微针',
            benefits: [
              '深度保湿并增加皮肤饱满度',
              '提升弹性与光滑度',
            ],
          },
        ],
      },
      {
        id: 20,
        category: 'skin',
        title: '热玛吉五代（Thermage® FLX）',
        description: '第五代无创单极射频紧致抗衰设备，针对眼部、面部、颈部及身体肌肤，提拉紧致、平滑皱纹、重塑轮廓',
        image: thermage,
        purpose: '通过获得FDA认证的单极射频技术，将能量精准传递至真皮深层，加热刺激胶原蛋白即刻收缩并促进胶原大量新生。有效改善眼部细纹与松弛、面部轮廓模糊、颈部纹路以及身体（如腹部、手臂、大腿、臀部）的皮肤松弛与皱纹。',
        mechanism: '采用独家 AccuREP™ 智能技术，在每次脉冲前自动微调能量输出，确保每一发治疗能量精准均一。结合舒适的震动冷却系统，将单极射频能量深层加热至真皮层及皮下组织，激活胶原蛋白重塑与新生，实现全方位提拉紧致。',
        duration: '单次治疗通常需要45-90分钟（依眼部、面部、颈部或身体治疗部位而定）。治疗后数月内胶原蛋白持续重塑，效果在2–6个月达到最佳，可维持12–24个月。',
        features: [
          '眼部、面部、颈部及身体全面紧致提拉',
          'AccuREP™ 智能能量精准输出',
          '深度激活胶原蛋白新生重塑',
          '无创无恢复期，效果持久自然',
        ],
      },
    ],
    details: '了解详情',
  }
};

const Services = () => {
  const { lang } = useLang();
  const c = content[lang];
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedService, setSelectedService] = useState(null);

  const filteredServices = selectedCategory === 'all'
    ? c.services
    : c.services.filter(service => service.category === selectedCategory);

  // Helper function to create URL slug from service title
  const createSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[()]/g, '')
      .replace(/\|/g, '-')
      .replace(/™/g, '')
      .replace(/®/g, '')
      .replace(/[^\w-]/g, '');
  };

  // Service image URL mapping based on service title/ID
  const getServiceImageUrl = (service) => {
    const imageMap = {
      'IV Therapy': 'https://www.haloaestheticclinic.com/static/media/iv.jpg',
      'Mesotherapy': 'https://www.haloaestheticclinic.com/static/media/mesotherapy.jpg',
      'PRP (Platelet-Rich Plasma)': 'https://www.haloaestheticclinic.com/static/media/prp.jpg',
      'Dermal Filler': 'https://www.haloaestheticclinic.com/static/media/filler.jpg',
      'Neurotoxin': 'https://www.haloaestheticclinic.com/static/media/soft2.jpg',
      'Belkyra (Kybella)': 'https://www.haloaestheticclinic.com/static/media/belkyra.png',
      'Sculptra': 'https://www.haloaestheticclinic.com/static/media/soft3.jpg',
      'Radiesse': 'https://www.haloaestheticclinic.com/static/media/radiesse.jpg',
      'HArmonyCa Hybrid Injectable': 'https://www.haloaestheticclinic.com/static/media/harmonyca.png',
      'Silhouette InstaLift / Thread Lifting': 'https://www.haloaestheticclinic.com/static/media/instalift.jpg',
      'HydraFacial': 'https://www.haloaestheticclinic.com/static/media/hydrafacial.jpg',
      'BBL (BroadBand Light) HERO': 'https://www.haloaestheticclinic.com/static/media/BBLHERO.png',
      'Ulthera Prime': 'https://www.haloaestheticclinic.com/static/media/ultherapy.png',
      'Radio Frequency Microneedling | Potenza': 'https://www.haloaestheticclinic.com/static/media/Potenza.jpg',
      'Spectrum Therapy™': 'https://www.haloaestheticclinic.com/static/media/skincare2.jpg',
      'Visia® Skin Analysis': 'https://www.haloaestheticclinic.com/static/media/visia.png',
      'Skin Tag Removal': 'https://www.haloaestheticclinic.com/static/media/hyfracator.png',
      'PicoSure Pro': 'https://www.haloaestheticclinic.com/static/media/picosurepro.png',
      'Thermage® FLX': 'https://www.haloaestheticclinic.com/static/media/thermage.png',
      '热玛吉五代（Thermage® FLX）': 'https://www.haloaestheticclinic.com/static/media/thermage.png'
    };
    
    // Try to match by title
    if (imageMap[service.title]) {
      return imageMap[service.title];
    }
    
    // Fallback: try to extract filename from imported image
    try {
      if (service.image) {
        const imgStr = service.image.toString();
        // Extract filename from webpack path
        const filenameMatch = imgStr.match(/([^/]+\.(jpg|png|jpeg|gif|webp))/i);
        if (filenameMatch) {
          const filename = filenameMatch[1];
          // Use static media path (webpack default)
          return `https://www.haloaestheticclinic.com/static/media/${filename}`;
        }
      }
    } catch (e) {
      // Ignore
    }
    
    // Final fallback
    return 'https://www.haloaestheticclinic.com/logo.jpg';
  };

  // Helper function to create 40-60 word description from service data
  const createDescription = (service) => {
    if (lang === 'en') {
      // Use purpose if available, otherwise combine description and purpose
      const baseText = service.purpose || service.description;
      // Ensure it's 40-60 words
      const words = baseText.split(' ');
      if (words.length >= 40 && words.length <= 60) {
        return baseText;
      } else if (words.length < 40) {
        // Add mechanism or features to reach 40 words
        const additional = service.mechanism ? service.mechanism.split(' ').slice(0, 40 - words.length).join(' ') : '';
        return `${baseText} ${additional}`.trim();
      } else {
        // Trim to 60 words
        return words.slice(0, 60).join(' ');
      }
    } else {
      // Chinese version
      const baseText = service.purpose || service.description;
      const chars = baseText.split('');
      // For Chinese, aim for 40-60 characters (roughly equivalent to 40-60 words in English)
      if (chars.length >= 40 && chars.length <= 60) {
        return baseText;
      } else if (chars.length < 40) {
        const additional = service.mechanism ? service.mechanism.split('').slice(0, 40 - chars.length).join('') : '';
        return `${baseText}${additional}`;
      } else {
        return chars.slice(0, 60).join('');
      }
    }
  };

  // Generate JSON-LD Service schemas for all services
  const serviceSchemas = c.services
    .filter(service => {
      // Filter out duplicate body versions (keep main services only)
      return !service.id.toString().includes('b');
    })
    .map(service => {
      const slug = createSlug(service.title);
      const description = createDescription(service);
      
      return {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": service.title,
        "serviceType": service.title,
        "description": description,
        "url": `https://www.haloaestheticclinic.com/services#${slug}`,
        "image": getServiceImageUrl(service),
        "provider": {
          "@id": "https://www.haloaestheticclinic.com/#organization"
        },
        "areaServed": {
          "@type": "City",
          "name": "Richmond Hill"
        }
      };
    });

  // Add special service pages that have dedicated routes
  const additionalServices = [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": lang === 'en' ? "Asian Skin Specialized Treatment" : "亚洲皮肤专业治疗",
      "serviceType": "Asian Skin Treatment",
      "description": lang === 'en'
        ? "Specialized aesthetic treatments designed specifically for Asian skin types. Includes hyperpigmentation treatment, melasma solutions, and gentle skincare regimens tailored to Asian skin characteristics."
        : "专为亚洲肤质设计的专业医美治疗。包括色素沉着治疗、黄褐斑解决方案和针对亚洲皮肤特性的温和护肤方案。",
      "url": "https://www.haloaestheticclinic.com/asian-skin-treatment",
      "image": "https://www.haloaestheticclinic.com/images/skin.jpg",
      "provider": {
        "@id": "https://www.haloaestheticclinic.com/#organization"
      },
      "areaServed": {
        "@type": "City",
        "name": "Richmond Hill"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": lang === 'en' ? "After-Hours Aesthetic Services" : "延长服务时间医美服务",
      "serviceType": "After-Hours Aesthetic Services",
      "description": lang === 'en'
        ? "Extended hours aesthetic services available every Friday from 1PM to 9PM. Includes injectable treatments, advanced skincare procedures, and body contouring services for busy professionals."
        : "每周五下午1点至晚上9点提供延长服务时间医美服务。包括注射治疗、高级皮肤护理程序和身体塑形服务，方便忙碌的专业人士。",
      "url": "https://www.haloaestheticclinic.com/after-hours-services",
      "image": "https://www.haloaestheticclinic.com/logo.jpg",
      "provider": {
        "@id": "https://www.haloaestheticclinic.com/#organization"
      },
      "areaServed": {
        "@type": "City",
        "name": "Richmond Hill"
      }
    }
  ];

  // Combine all service schemas into a single array
  const allServiceSchemas = [...serviceSchemas, ...additionalServices];

  // LocalBusiness schema for provider reference
  const localBusinessSchema = {
    "@type": "MedicalBusiness",
    "@id": "https://www.haloaestheticclinic.com/#organization",
    "name": "Halo Aesthetic Clinic",
    "url": "https://www.haloaestheticclinic.com",
    "image": "https://www.haloaestheticclinic.com/logo.jpg",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.haloaestheticclinic.com/logo.jpg"
    },
    "telephone": "+14377555409",
    "email": "info@haloaestheticclinic.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "1595 16th Ave Suite 103",
      "addressLocality": "Richmond Hill",
      "addressRegion": "ON",
      "postalCode": "L4B 3N9",
      "addressCountry": "CA"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Tuesday",
        "opens": "11:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Wednesday",
        "opens": "11:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Thursday",
        "opens": "11:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Friday",
        "opens": "13:00",
        "closes": "21:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "11:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Sunday",
        "opens": "11:00",
        "closes": "19:00"
      }
    ],
    "priceRange": "$$",
    "areaServed": {
      "@type": "City",
      "name": "Richmond Hill"
    },
    "medicalSpecialty": "Dermatology"
  };

  // Complete JSON-LD with @graph format for Google AEO
  const completeJsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      localBusinessSchema,
      ...allServiceSchemas
    ]
  };

  return (
    <>
      <Helmet>
        <title>{c.pageTitle} - Halo Aesthetic Clinic</title>
        <meta name="description" content={c.pageDesc} />
        <link rel="canonical" href="https://www.haloaestheticclinic.com/services" />
        {/* JSON-LD Structured Data - Complete @graph format with LocalBusiness + 17 Services */}
        <script type="application/ld+json">
          {JSON.stringify(completeJsonLd)}
        </script>
      </Helmet>
      <div className="bg-softGradient bg-no-repeat bg-top text-text">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-section">
        {/* 页面标题 */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4 text-gray-900">{c.pageTitle}</h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">{c.pageDesc}</p>
        </div>

        {/* 分类筛选 */}
        <div className="grid grid-cols-2 gap-3 sm:flex sm:justify-center sm:space-x-4 mb-12 max-w-md mx-auto sm:max-w-none">
          {c.categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-3 py-2 sm:px-6 sm:py-2 rounded-xl transition-all text-sm sm:text-base ${
                selectedCategory === category.id
                  ? 'text-gray-900 shadow-soft hover:shadow-glow hover:brightness-110 border border-champagne/60'
                  : 'bg-white/60 backdrop-blur-md border border-sage/50 text-gray-700 hover:shadow-glow'
              }`}
              style={selectedCategory === category.id ? {
                backgroundImage:
                  'linear-gradient(90deg, rgba(217,195,169,1) 0%, rgba(217,195,169,0.8) 40%, rgba(217,195,169,0.3) 100%)'
              } : {}}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* 服务列表 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredServices.map((service) => {
            const slugMap = {
              1: 'iv-therapy',
              2: 'mesotherapy',
              3: 'prp-vampire-facial',
              4: 'dermal-fillers',
              '4b': 'dermal-fillers-body',
              5: 'botox-neurotoxin',
              6: 'belkyra-kybella',
              '6b': 'belkyra-kybella-body',
              7: 'sculptra',
              8: 'radiesse',
              18: 'harmonyca',
              19: 'instalift-thread-lift',
              9: 'hydrafacial',
              10: 'bbl-hero',
              11: 'ulthera-prime',
              '11b': 'ulthera-prime-body',
              12: 'potenza-rf-microneedling',
              13: 'spectrum-therapy',
              14: 'visia-skin-analysis',
              15: 'skin-tag-removal',
              16: 'picosure-pro',
              17: 'microneedling-treatments',
              20: 'thermage-flx',
            };
            const serviceSlug = service.slug || slugMap[service.id] || createSlug(service.title);

            return (
              <div
                key={service.id}
                className="bg-white/80 backdrop-blur-sm rounded-xl shadow-card overflow-hidden border border-champagne/40 flex flex-col justify-between"
              >
                <div>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-6">
                    <h3 className="text-xl font-semibold mb-2 text-gray-900">{service.title}</h3>
                    <p className="text-gray-700 mb-4">{service.description}</p>
                    <div className="space-y-2 mb-6">
                      {service.features.map((feature, index) => (
                        <div key={index} className="flex items-center">
                          <svg
                            className="w-5 h-5 text-[#2E6B4C] mr-2"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          <span className="text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="px-6 pb-6 pt-0">
                  <Link 
                    to={`/services/${serviceSlug}`}
                    className="w-full block text-center px-4 py-2.5 rounded-xl shadow-soft transition-all text-gray-900 font-medium hover:shadow-glow hover:brightness-110 border border-champagne/60"
                    style={{
                      backgroundImage:
                        'linear-gradient(90deg, rgba(217,195,169,1) 0%, rgba(217,195,169,0.8) 40%, rgba(217,195,169,0.3) 100%)'
                    }}
                  >
                    {c.details}
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Service Detail Modal */}
      {selectedService && (
        <ServiceDetail
          service={selectedService}
          onClose={() => setSelectedService(null)}
          lang={lang}
        />
      )}
      </div>
    </>
  );
};

export default Services; 